import * as fcl from '@onflow/fcl'
import { AFL_LISTING_TRACKER_ADDRESS } from './addresses'

fcl.config({
  'accessNode.api': import.meta.env.VITE_ACCESS_NODE,
  'discovery.wallet': import.meta.env.VITE_WALLET_DISCOVERY_FALLBACK,
  'discovery.authn.endpoint': import.meta.env.VITE_WALLET_DISCOVERY,
  'walletconnect.projectId': import.meta.env.VITE_WALLET_PROJECT_ID,
  'discovery.authn.exclude': '0x55ad22f01ef568a1',
  'discovery.wallet.method': 'IFRAME/RPC', // IFRAME/RPC, POP/RPC, TAB/RPC, HTTP/POST, or EXT/RPC
  'app.detail.title': 'AFL Mint',
  'app.detail.icon':
    'https://afl-mint-production.s3.ap-southeast-2.amazonaws.com/public/general/android-chrome-192x192.png',
  // CONTRACTS
  '0xAFLContracts': import.meta.env.VITE_AFL_CONTRACTS,
  '0xAflListingTrackerMarketplace': AFL_LISTING_TRACKER_ADDRESS,
  '0xAFLListingTracker': AFL_LISTING_TRACKER_ADDRESS,
  '0xUSDCFlow': import.meta.env.VITE_USDCFLOW_CONTRACT,
  '0xMetadataViews': import.meta.env.VITE_METADATAVIEWS,
  '0xFungibleToken': import.meta.env.VITE_FUNGIBLE_CONTRACT,
  '0xNFT': import.meta.env.VITE_NFT_CONTRACT,
  '0xFlow': import.meta.env.VITE_FLOW_CONTRACT,
  '0xEVM': import.meta.env.VITE_EVM_CONTRACT,
  '0xViewResolver': import.meta.env.VITE_VIEW_RESOLVER,
  '0xFTMetadataViews': import.meta.env.VITE_FT_METADATA_VIEWS,
  '0xEVMBridgeContract': import.meta.env.VITE_EVM_BRIDGE_CONTRACT,
  '0xScopedFTProviders': import.meta.env.VITE_SCOPED_FT_PROVIDERS,
  '0xBurner': import.meta.env.VITE_BURNER_CONTRACT
})
